
class CaptchaWithFallbackController {

  constructor($http, Captcha, $rootScope) {
    this._$http = $http;
    this._Captcha = Captcha;
    this.reCaptchaResponse = null;
    this.loading = false;
    this.renderReCaptcha = true;
    this._$rootScope = $rootScope;
    this.checkCountryAndRecaptcha();
  }

  checkCountryAndRecaptcha() {
    this._$rootScope.reCaptchaFailed ?
      this.fallback() :
      this.isChina().then(this.fallback.bind(this),
        () => {
          if (!window.recaptcha) {
            this.waitReCaptcha(15);
          }
        }
      );
  }

  $onInit() {
    const validate = () => {
      if (this.loading) {
        this.fallback();
        return Promise.reject();
      }
      return this.renderReCaptcha ? this.validateReCaptcha() : this.validateFallbackCaptcha();
    };
    this.onInit({ validate });
  };

  fallback() {
    this.loading = false;
    this.renderReCaptcha = false;
    this._$rootScope.reCaptchaFailed = true;
  }

  waitReCaptcha(seconds) {
    this.loading = true;
    setTimeout(() => {
      !window.recaptcha && this.fallback();
    }, seconds * 1000);
  }

  validateReCaptcha() {
    return this.reCaptchaResponse ? Promise.resolve() : Promise.reject();
  }

  validateFallbackCaptcha() {
    const captcha = new this._Captcha();
    const userEnteredCaptchaCode = captcha.getUserEnteredCaptchaCode();
    const captchaId = captcha.getCaptchaId();

    return this._$http({
      headers: {'Content-Type': 'application/json; charset=utf-8'},
      method: 'POST',
      url: '/captcha/validate',
      data: {
        userEnteredCaptchaCode: userEnteredCaptchaCode,
        captchaId: captchaId
      }
    }).then(function (response) {
      if (response.data.success === false) {
        captcha.reloadImage();
        return Promise.reject();
      }
    });
  }

  isChina() {
    return this._$http({
      headers: {'Content-Type': 'application/json; charset=utf-8'},
      method: 'GET',
      url: '/captcha/ischina',
    }).then(function (response) {
      if (!response.data) {
        return Promise.reject();
      }
    })
  }
}

CaptchaWithFallbackController.$inject = ['$http', 'Captcha', '$rootScope'];

export default CaptchaWithFallbackController;



// WEBPACK FOOTER //
// ./client/app/common/captcha-with-fallback/captcha-with-fallback.controller.js